function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var _excluded = ["flush", "indent", "label", "onChange", "options", "selectable"];

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

import React, { Fragment } from 'react';
import Collapse from "../Collapse/Collapse";
import ListGroup from "../List/ListGroup";
import TreeItem from "./TreeItem";

function Tree(_ref) {
  var _ref$flush = _ref.flush,
      flush = _ref$flush === void 0 ? true : _ref$flush,
      _ref$indent = _ref.indent,
      indent = _ref$indent === void 0 ? 0 : _ref$indent,
      label = _ref.label,
      onChange = _ref.onChange,
      options = _ref.options,
      _ref$selectable = _ref.selectable,
      selectable = _ref$selectable === void 0 ? false : _ref$selectable,
      props = _objectWithoutProperties(_ref, _excluded);

  var updateOption = function updateOption(option, properties) {
    var index = options.indexOf(option);

    if (index !== -1) {
      onChange([].concat(_toConsumableArray(options.slice(0, index)), [_objectSpread(_objectSpread({}, options[index]), properties)], _toConsumableArray(options.slice(index + 1))));
    }
  };

  return /*#__PURE__*/React.createElement(ListGroup, _extends({
    flush: flush
  }, props), options.map(function (option, index) {
    return /*#__PURE__*/React.createElement(Fragment, {
      key: option.key || index
    }, /*#__PURE__*/React.createElement(TreeItem, {
      indent: indent,
      label: label,
      option: option,
      selectable: selectable,
      updateOption: updateOption
    }), option.children && option.children.length > 0 && /*#__PURE__*/React.createElement(Collapse, {
      className: "list-group-item p-0",
      isOpen: option.expanded
    }, /*#__PURE__*/React.createElement(Tree, {
      indent: indent + 1,
      label: label,
      options: option.children,
      onChange: function onChange(children) {
        var allSelected = children === null || children === void 0 ? void 0 : children.every(function (child) {
          return child.selected;
        });
        var noneSelected = children === null || children === void 0 ? void 0 : children.every(function (child) {
          return child.selected === false;
        });
        updateOption(option, {
          children: children,
          selected: allSelected ? true : noneSelected ? false : null
        });
      },
      selectable: selectable
    })));
  }));
}

Tree.displayName = "Tree";
export default Tree;